import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import PlainTabControl from 'components/tab-control/PlainTabControl';
import { DaymadeDesignSystemPreviewComponentInfo } from '../';

const ComponentPreview = () => {
  return (
    <AboutUsModule background={'grey'}>
      <AboutUsSiteContainer>
        <div style={{ marginBottom: 24 }}>
          <h3 className="aboutUsTypographyHeaderLarge">Plain Tab Control</h3>
          <p>
            A tab component that is very plain in style. It provides minimal
            styling other than the tab bar buttons.
          </p>
        </div>
        <PlainTabControl
          pages={[
            {
              title: 'First',
              content: <p>This is the content on the first tab</p>,
            },
            {
              title: 'Second',
              content: <p>This is the content on the second tab</p>,
            },
          ]}
        />
        <br />
        <p>
          The tab buttons can have subtitles. The button text content is aligned
          top, rather than centered.
        </p>
        <PlainTabControl
          pages={[
            {
              title: 'First',
              subtitle: 'Number one',
              content: <p>This is the content on the first tab</p>,
            },
            {
              title: 'Second',
              content: <p>This is the content on the second tab</p>,
            },
          ]}
        />
        <br />
        <br />
        <p>
          It supports a sensible number of buttons, currently we've only needed
          two. It never wraps.
        </p>
        <PlainTabControl
          pages={[
            {
              title: 'First',
              content: <p>This is the content on the first tab</p>,
            },
            {
              title: 'Second',
              content: <p>This is the content on the second tab</p>,
            },
            {
              title: 'Third',
              content: <p>This is the content on the third tab</p>,
            },
            {
              title: 'Fourth',
              content: <p>This is the content on the fourth tab</p>,
            },
            {
              title: 'Fifth',
              content: <p>This is the content on the fifth tab</p>,
            },
            {
              title: 'Sixth',
              content: <p>This is the content on the sixth tab</p>,
            },
            {
              title: 'Seventh',
              content: <p>This is the content on the seventh tab</p>,
            },
          ]}
        />
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Plain Tab Control',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
